import { LOGIN_URL } from '../auth'
import { BuildInfo } from './BuildInfo'

// The login screen: a single button that hands off to the EBI users service.
//
// A full browser navigation, deliberately not fetch(): the response is a redirect
// to the identity provider, which a background request cannot follow.
export function Login() {
  const returnUrl = window.location.pathname + window.location.search

  return (
    <main className="page">
      <div className="login">
        <h1 className="page__title">Sign in</h1>
        <p className="page__subtitle">Weather app</p>

        <div className="login__form">
          <p className="muted">You'll be redirected to the EBI users service.</p>
          <button
            type="button"
            className="refresh"
            onClick={() => {
              window.location.assign(`${LOGIN_URL}?returnUrl=${encodeURIComponent(returnUrl)}`)
            }}
          >
            Sign in with EBI
          </button>
        </div>

        <BuildInfo />
      </div>
    </main>
  )
}
